import React from "react";

const HeaderPanel = ({
  event_id,
  event_name,
  division,
  divisions,
  hasNodes = false,
  bracket_template_id,
}) => {
  //* Division change method
  const onDivisionChange = ({ target }) => {
    const value = target.value;
    if (value != division) {
      window.location.href = `${window.APP_URL}manager/division_bracket_template_edit_v2/${value}#/division_bracket_template_edit_v2`;
    }
  };

  const onGotoChange = ({ target }) => {
    const value = target.value;

    const commonUrlPrefix = window.APP_URL;
    if (value == "") return "";

    let redirectUrl = "";

    if (value == "dashboard") {
      redirectUrl = `${commonUrlPrefix}manager/home`;
    } else if (value == "list_event") {
      redirectUrl = `${commonUrlPrefix}manager/event#/event`;
    } else {
      if (division > 0) {
        const commonDivisionUrl = `${commonUrlPrefix}manager/division_${value}_edit/${division}#division_${value}_edit`;

        switch (value) {
          case "pool":
          case "poolgame":
          case "bracket_template":
          case "standing":
          case "field":
            redirectUrl = commonDivisionUrl;
            break;
        }
      }

      if (event_id > 0) {
        const commonEventUrl = `${commonUrlPrefix}manager/division_game_${value}/${event_id}#division_game_${value}`;

        switch (value) {
          case "schedule_v2":
          case "edit":
            redirectUrl = commonEventUrl;
            break;
          case "score_edit":
            redirectUrl = `${commonUrlPrefix}manager/division_score_edit/${event_id}#division_score_edit`;
            break;
          case "registration":
            redirectUrl = `${commonUrlPrefix}manager/event_registration_item#/event_registration_item/${event_id}`;
            break;
          case "team":
            redirectUrl = `${commonUrlPrefix}manager/event_moveteam/${event_id}#event_moveteam`;
            break;
          case "roster":
            redirectUrl = `${commonUrlPrefix}manager/roster_eventrosters/${event_id}#roster`;
            break;
          case "report":
            redirectUrl = `${commonUrlPrefix}manager/report_event#/report_event/${event_id}`;
            break;
        }
      }
    }

    if (redirectUrl !== "") {
      window.location.href = redirectUrl;
    }
  };

  const redirectToV1 = () => {
    let redirectionURL = `${window.APP_URL}`;
    if (division) {
      redirectionURL += `manager/division_bracket_template_edit/${division}#/division_bracket_template_edit`;
    } else {
      if (bracket_template_id) {
        redirectionURL += `manager/bracket_template_edit/${bracket_template_id}#/bracket_template_edit`;
      } else {
        redirectionURL += `manager/bracket_template_create#/bracket_template_create`;
      }
    }
    window.location.href = redirectionURL;
  };

  return (
    <div className="row header-panel">
      <div className="col-md-6">
        <h5>{event_name}</h5>
      </div>
      <div className="col-md-6 text-right">
        {!hasNodes && (
          <button
            className="btn btn-primary btn-sm mr-2"
            onClick={redirectToV1}
          >
            Bracket Builder V1.0
          </button>
        )}
        {division && (
          <select
            name="divisions"
            id="divisions"
            onChange={onDivisionChange}
            value={division}
            className="form-control teamSelect d-inline-block roundedSelect"
          >
            {divisions.map((div, index) => (
              <option
                key={index}
                value={div.id}
                style={{
                  backgroundColor: div.color_scheme_data.bg,
                  color: div.color_scheme_data.text,
                }}
              >
                {div.label}
              </option>
            ))}
          </select>
        )}
        <select
          name="go_to"
          id="go_to"
          className="form-control gotoSelect d-inline-block roundedSelect"
          onChange={onGotoChange}
        >
          <option value="">GO TO</option>
          <option value="dashboard">DASHBOARD</option>
          <option value="list_event">EVENTS</option>
          {event_id > 0 && (
            <>
              <option value="registration">REGISTRATIONS</option>
              <option value="team">1) TEAMS</option>
            </>
          )}
          {division && (
            <>
              <option value="pool">2) POOLS</option>
              <option value="poolgame">3) MATCHUPS</option>
              <option value="bracket_template">4) BRACKETS</option>
              <option value="field">5) FIELDS</option>
            </>
          )}
          {event_id > 0 && (
            <>
              <option value="schedule_v2">WHITEBOARD</option>
              <option value="edit">GAME EDITOR</option>
              <option value="roster">ROSTERS</option>
              <option value="score_edit">SCORES</option>
            </>
          )}
          {division && <option value="standing">STANDINGS</option>}
          {event_id > 0 && <option value="report">REPORTS</option>}
        </select>
      </div>
    </div>
  );
};

export default HeaderPanel;
